import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function ValidationInvalidColourMedium(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("g", {
    fill: "#C00",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, React.createElement("path", {
    d: "M11.993.18C5.469.18.18 5.47.18 11.993c0 6.524 5.289 11.812 11.813 11.812 6.524 0 11.812-5.288 11.812-11.812C23.805 5.469 18.517.18 11.993.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M12.742 6a.75.75 0 10-1.5 0v7.5a.75.75 0 001.5 0V6zm0 11.096a.75.75 0 10-1.5 0v.15a.75.75 0 001.5 0v-.15z"
  })));
}

export default ValidationInvalidColourMedium;
//# sourceMappingURL=ValidationInvalidColourMedium.js.map